import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const server = [
    // {
    //     path: '/springFestival',
    //     name: 'SpringFestival',
    //     component: () => import('../../views/activityGather/springFestival/index.vue')
    // },
    {
        path: '/attemptPlay',
        name: 'AttemptPlay',
        component: () => import('../../views/activityGather/attemptPlay/index.vue')
    },
    {
        path: '/trySdk',
        name: 'TrySdk',
        component: () => import('../../views/activityGather/attemptPlay/trySdk.vue')
    },
    {
        path: '/DNFgroupoid',
        name: 'DNFgroupoId',
        component: () => import('../../views/activityGather/DNFgroupoid')
    },
    // {
    //     path: '/sixOneEightFestival',
    //     name: 'SixOneEightFestival',
    //     component: () => import('../../views/activityGather/sixOneEightFestival')
    // },
    {
        path: '/specialBuyWay',
        name: 'SpecialBuyWay',
        component: () => import('../../views/activityGather/specialBuyWay')
    },
    {
        path: '/channelGetCoupon',
        name: 'ChannelGetCoupon',
        component: () => import('../../views/activityGather/channelGetCoupon')
    },
    // {
    //     path: '/massiveGroupBuying',
    //     name: 'MassiveGroupBuying',
    //     component: () => import('../../views/activityGather/massiveGroupBuying')
    // },
    // {
    //     path: '/massiveGroupPayResult',
    //     name: 'MassiveGroupPayResult',
    //     component: () => import('../../views/activityGather/massiveGroupBuying/massiveGroupPayResult.vue')
    // },
    {
        path: '/thousandGroupBuying',
        name: 'ThousandGroupBuying',
        component: () => import('../../views/activityGather/thousandGroupBuying')
    },
    {
        path: '/thousandGroupPayResult',
        name: 'ThousandGroupPayResult',
        component: () => import('../../views/activityGather/thousandGroupBuying/thousandGroupPayResult.vue')
    },
    {
        path: '/preorder',
        name: 'Preorder',
        component: () => import('../../views/activityGather/preorder')
    },
    {
        path: '/customList',
        name: 'CustomList',
        component: () => import('../../views/activityGather/preorder/customList.vue')
    },
    {
        path: '/2026SpringFestival',
        name: 'NewYearFestival',
        component: () => import('../../views/activityGather/newYearFestival')
    },
]

export default server